import {useCallback, useEffect, useRef} from 'react';

import {MAX_DRAWER_WIDTH, MIN_DRAWER_WIDTH} from './constants';
import {useWBAgentContextStore} from './WBAgentContextStore';

export function useDrawerResize() {
  const dragging = useRef(false);
  const width = useWBAgentContextStore(s => s.drawerWidth);
  const setWidth = useWBAgentContextStore(s => s.setDrawerWidth);

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    dragging.current = true;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }, []);

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!dragging.current) {
        return;
      }
      const maxWidth = Math.min(MAX_DRAWER_WIDTH, window.innerWidth * 0.75);
      const newWidth = Math.min(
        maxWidth,
        Math.max(MIN_DRAWER_WIDTH, window.innerWidth - e.clientX)
      );
      setWidth(newWidth);
    },
    [setWidth]
  );

  const onMouseUp = useCallback(() => {
    dragging.current = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }, []);

  const clampToViewport = useCallback(() => {
    const currentWidth = useWBAgentContextStore.getState().drawerWidth;
    const maxWidth = Math.min(MAX_DRAWER_WIDTH, window.innerWidth * 0.75);
    if (currentWidth > maxWidth) {
      setWidth(maxWidth);
    }
  }, [setWidth]);

  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    window.addEventListener('resize', clampToViewport);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('resize', clampToViewport);
    };
  }, [onMouseMove, onMouseUp, clampToViewport]);

  return {width, onMouseDown};
}
